class RefreshCoordinator {
  constructor() {
    this._currentRefreshPromise = null;
  }

  async executeRefresh(refreshUrl) {
    if (this._currentRefreshPromise) {
      return this._currentRefreshPromise;
    }

    this._currentRefreshPromise = this._doRefresh(refreshUrl);

    try {
      return await this._currentRefreshPromise;
    } finally {
      this._currentRefreshPromise = null;
    }
  }

  async _doRefresh(refreshUrl) {
    const response = await fetch(refreshUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const error = new Error(errorData.message || 'Refresh failed');
      error.status = response.status;
      throw error;
    }

    const data = await response.json();
    return data.accessToken;
  }
}

export const refreshCoordinator = new RefreshCoordinator();
